<form [formGroup]="emailForm">
    <span (click)="close()" style="cursor: pointer; float: right;font-size: 18px;font-weight: bold;margin-top: -20px;margin-right: -16px;">X</span>
    <label>{{label}}</label>
    

    <div class="error-message" style="text-align: left;"
        *ngIf="!emailForm.controls['EmailAddress'].errors?.required && emailForm.controls['EmailAddress'].errors?.email">
        {{emailValid}}
    </div>

    <input aria-label="State" placeholder="{{placeHolder}}" class="form-control patientid" formControlName="EmailAddress">
    <div style="color:green;text-align: left;color: blue;" *ngIf="success">{{success}}</div>
    <div style="text-align: left" class="error-message" *ngIf="error">{{error}}</div>
    <div class="col-md-12">
        <input type="submit" style="width: 300px;" [disabled]="!emailForm.valid" id="login" (click)="sendEmail()" class="btn btn-main"
            value="{{buttonText}}" />
    </div>
</form>